import { inject } from '@angular/core';
import { Router, CanMatchFn } from '@angular/router';

import { ProfilePermission } from '@/app/api/profile';
import { PermissionsService } from '@/app/core/services/permissions';

export function permissionGuard(permissionToCheck: ProfilePermission | ProfilePermission[]): CanMatchFn {
  return () => {
    const router = inject(Router);
    const permissionsService = inject(PermissionsService);

    if (permissionsService.hasPermissions(permissionToCheck)) {
      return true;
    }

    return router.createUrlTree(['/']);
  };
}
